/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type C4CModeEnum = "CASE4CAUSE" | "GRAPEFULCLUB" | "NONE" | "%future added value";
export type CartUpdatePromoCodesInput = {
    readonly promoCodes?: ReadonlyArray<string | null> | null;
    readonly noGiftCards?: boolean | null;
    readonly key?: string | null;
    readonly clientMutationId?: string | null;
};
export type CartUpdatePromoCodesMutationVariables = {
    readonly input: CartUpdatePromoCodesInput;
};
export type CartUpdatePromoCodesMutationResponse = {
    readonly cartUpdatePromoCodes: ({
        readonly cart: ({
            readonly id: string;
            readonly eventHostFirstName: string | null;
            readonly eventId: string | null;
            readonly totalMinusSavings: number | null;
            readonly promoCodeIsValid: boolean | null;
            readonly promoCodes: ReadonlyArray<({
                readonly id: string;
                readonly promoDescription: string | null;
                readonly code: string | null;
                readonly discountShipping: string | null;
                readonly thresholds: ReadonlyArray<({
                    readonly spendAmount: string | null;
                    readonly spendQuantity: string | null;
                    readonly discountAmount: string | null;
                    readonly discountFree: string | null;
                    readonly discountTax: string | null;
                    readonly discountShipping: string | null;
                }) | null> | null;
            }) | null> | null;
            readonly wordPressCoupons: ReadonlyArray<({
                readonly code: string | null;
                readonly couponDescription: string | null;
                readonly storeBalance: number | null;
                readonly yotpoCouponCode: string | null;
            }) | null> | null;
            readonly wordPressCouponSavings: ReadonlyArray<number | null> | null;
            readonly shippingInfo: ({
                readonly shippingMethod: string | null;
            }) | null;
            readonly shippingPrice: number | null;
            readonly shippingCosts: ({
                readonly upsGround: number | null;
                readonly upsSecondDayAir: number | null;
            }) | null;
            readonly promoCodeSavings: number | null;
            readonly totalSavings: number | null;
            readonly total: number | null;
            readonly viaQualifiedCartTotal: number | null;
            readonly subTotalPriceOfItems: number | null;
            readonly subTotalPriceOfItemsWithPromoCodes: number | null;
            readonly taxTotal: number | null;
            readonly c4cMode: C4CModeEnum | null;
        }) | null;
    }) | null;
};
export type CartUpdatePromoCodesMutation = {
    readonly response: CartUpdatePromoCodesMutationResponse;
    readonly variables: CartUpdatePromoCodesMutationVariables;
};



/*
mutation CartUpdatePromoCodesMutation(
  $input: CartUpdatePromoCodesInput!
) {
  cartUpdatePromoCodes(input: $input) {
    cart {
      id
      eventHostFirstName
      eventId
      totalMinusSavings
      promoCodeIsValid
      promoCodes {
        id
        promoDescription
        code
        discountShipping
        thresholds {
          spendAmount
          spendQuantity
          discountAmount
          discountFree
          discountTax
          discountShipping
        }
      }
      wordPressCoupons {
        code
        couponDescription
        storeBalance
        yotpoCouponCode
        id
      }
      wordPressCouponSavings
      shippingInfo {
        shippingMethod
      }
      shippingPrice
      shippingCosts {
        upsGround
        upsSecondDayAir
      }
      promoCodeSavings
      totalSavings
      total
      viaQualifiedCartTotal
      subTotalPriceOfItems
      subTotalPriceOfItemsWithPromoCodes
      taxTotal
      c4cMode
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CartUpdatePromoCodesInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CartUpdatePromoCodesInput!"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "shippingPrice",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventId",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalMinusSavings",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoCodeIsValid",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "discountShipping",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "promoCodes",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCode",
        "plural": true,
        "selections": [
            (v3 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "promoDescription",
                "args": null,
                "storageKey": null
            },
            (v7 /*: any*/),
            (v8 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "thresholds",
                "storageKey": null,
                "args": null,
                "concreteType": "PromoCodeThresholds",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "spendAmount",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "spendQuantity",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discountAmount",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discountFree",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discountTax",
                        "args": null,
                        "storageKey": null
                    },
                    (v8 /*: any*/)
                ]
            }
        ]
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "couponDescription",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "storeBalance",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "yotpoCouponCode",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "wordPressCouponSavings",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "shippingInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "CartShippingInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingMethod",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventHostFirstName",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "shippingCosts",
        "storageKey": null,
        "args": null,
        "concreteType": "CartShippingCosts",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "upsGround",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "upsSecondDayAir",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoCodeSavings",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalSavings",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "viaQualifiedCartTotal",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItems",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItemsWithPromoCodes",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "taxTotal",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "c4cMode",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CartUpdatePromoCodesMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartUpdatePromoCodes",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CartUpdatePromoCodesPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v9 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "wordPressCoupons",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "WordPressCoupon",
                                    "plural": true,
                                    "selections": [
                                        (v7 /*: any*/),
                                        (v10 /*: any*/),
                                        (v11 /*: any*/),
                                        (v12 /*: any*/)
                                    ]
                                },
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                (v18 /*: any*/),
                                (v19 /*: any*/),
                                (v20 /*: any*/),
                                (v21 /*: any*/),
                                (v22 /*: any*/),
                                (v23 /*: any*/),
                                (v24 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "CartUpdatePromoCodesMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartUpdatePromoCodes",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CartUpdatePromoCodesPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v9 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "wordPressCoupons",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "WordPressCoupon",
                                    "plural": true,
                                    "selections": [
                                        (v7 /*: any*/),
                                        (v10 /*: any*/),
                                        (v11 /*: any*/),
                                        (v12 /*: any*/),
                                        (v3 /*: any*/)
                                    ]
                                },
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                (v18 /*: any*/),
                                (v19 /*: any*/),
                                (v20 /*: any*/),
                                (v21 /*: any*/),
                                (v22 /*: any*/),
                                (v23 /*: any*/),
                                (v24 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "CartUpdatePromoCodesMutation",
            "id": null,
            "text": "mutation CartUpdatePromoCodesMutation(\n  $input: CartUpdatePromoCodesInput!\n) {\n  cartUpdatePromoCodes(input: $input) {\n    cart {\n      id\n      eventHostFirstName\n      eventId\n      totalMinusSavings\n      promoCodeIsValid\n      promoCodes {\n        id\n        promoDescription\n        code\n        discountShipping\n        thresholds {\n          spendAmount\n          spendQuantity\n          discountAmount\n          discountFree\n          discountTax\n          discountShipping\n        }\n      }\n      wordPressCoupons {\n        code\n        couponDescription\n        storeBalance\n        yotpoCouponCode\n        id\n      }\n      wordPressCouponSavings\n      shippingInfo {\n        shippingMethod\n      }\n      shippingPrice\n      shippingCosts {\n        upsGround\n        upsSecondDayAir\n      }\n      promoCodeSavings\n      totalSavings\n      total\n      viaQualifiedCartTotal\n      subTotalPriceOfItems\n      subTotalPriceOfItemsWithPromoCodes\n      taxTotal\n      c4cMode\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '7125faa4a810e1c788fca75a629e5773';
export default node;
